(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    try {
      if (window.__customCardSliderReady) return;
      window.__customCardSliderReady = true;

      function idx(slider) {
        var t = slider.querySelector('.custom-card-slider__track');
        return t && t.clientWidth ? Math.round(t.scrollLeft / t.clientWidth) : 0;
      }

      function goTo(slider, i, smooth) {
        var t = slider.querySelector('.custom-card-slider__track');
        if (!t) return;
        var n = t.children.length;
        if (n < 2) return;
        i = ((i % n) + n) % n;
        t.scrollTo({ left: i * t.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      }

      document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.custom-card-slider__arrow') : null;
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var slider = btn.closest('.custom-card-slider');
        if (!slider) return;
        slider.setAttribute('data-interacted', 'true');
        goTo(slider, idx(slider) + parseInt(btn.getAttribute('data-dir'), 10), true);
      }, true);

      document.addEventListener('touchstart', function (e) {
        var slider = e.target.closest ? e.target.closest('.custom-card-slider') : null;
        if (slider) slider.setAttribute('data-interacted', 'true');
      }, { passive: true });

      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        document.addEventListener('mouseover', function (e) {
          var media = e.target.closest ? e.target.closest('.custom-product-card__media') : null;
          if (!media || media.contains(e.relatedTarget)) return;
          var slider = media.querySelector('.custom-card-slider');
          if (!slider || slider.getAttribute('data-hover') !== 'true' || slider.getAttribute('data-interacted') === 'true') return;
          goTo(slider, 1, false);
        });

        document.addEventListener('mouseout', function (e) {
          var media = e.target.closest ? e.target.closest('.custom-product-card__media') : null;
          if (!media || media.contains(e.relatedTarget)) return;
          var slider = media.querySelector('.custom-card-slider');
          if (!slider) return;
          slider.removeAttribute('data-interacted');
          goTo(slider, 0, false);
        });
      }
    } catch (err) {
      console.warn('custom-card-slider error', err);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-actions"] && !Shopify.designMode) return;
  try {
    (function () {
    try {
      if (window.__kdActionsReady) return;
      window.__kdActionsReady = true;

      var FALLBACK_SELECTORS = [
        '[class*="Vtl-WishlistButton"]',
        'button[class*="wishlist" i]',
        '[class*="wishlist" i] button',
        '[data-wishlist-button]',
        '[data-wishlist-add]',
        '[id*="wishlist" i] button'
      ];

      // Never use these (header link, product cards, sticky bar)
      var SKIP = '.custom-product-card, sticky-add-to-cart, header';
      // Elements inside the image gallery (clicking them normally opens the zoom)
      var MEDIA =
        'media-gallery, [class*="media-gallery"], [class*="product-media"], slideshow-component, zoom-dialog, dialog';

      function attrText(el) {
        return (
          (el.textContent || '') + ' ' +
          (el.getAttribute('class') || '') + ' ' +
          (el.getAttribute('aria-label') || '') + ' ' +
          (el.id || '')
        );
      }

      // The app renders an empty wrapper div; the real click handler is on something inside it.
      // Pick the most button-like child, otherwise the innermost element, and let the event bubble.
      function pickTarget(el) {
        if (el.matches('button, a, [role="button"], input')) return el;
        var picks = [
          '[class*="WishlistIconButton"]',
          '[class*="Vtl-WishlistButton__"]',
          'button',
          '[role="button"]',
          'a'
        ];
        for (var i = 0; i < picks.length; i++) {
          var inner = el.querySelector(picks[i]);
          if (inner) return inner;
        }
        var node = el;
        while (node.firstElementChild) node = node.firstElementChild;
        return node;
      }

      function findPrimary(root) {
        var scope = root.closest('.shopify-section') || document;

        // 1) Button-like element that mentions "wishlist" (outside the image gallery)
        var all = scope.querySelectorAll('button, [role="button"], a');
        for (var i = 0; i < all.length; i++) {
          var t = all[i];
          if (root.contains(t) || t.closest(SKIP) || t.closest(MEDIA)) continue;
          if (/wishlist/i.test(attrText(t))) return t;
        }

        // 2) App wrapper (e.g. Vitals: Vtl-WishlistButtonWrapper)
        for (var s = 0; s < FALLBACK_SELECTORS.length; s++) {
          var found = scope.querySelectorAll(FALLBACK_SELECTORS[s]);
          for (var j = 0; j < found.length; j++) {
            var f = found[j];
            if (root.contains(f) || f.closest(SKIP) || f.closest(MEDIA)) continue;
            return f;
          }
        }
        return null;
      }

      function fire(el) {
        ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (type) {
          var Ctor = type.indexOf('pointer') === 0 && window.PointerEvent ? window.PointerEvent : window.MouseEvent;
          el.dispatchEvent(new Ctor(type, { bubbles: true, cancelable: true, view: window }));
        });
      }

      function isActive(el) {
        if (!el) return false;
        var nodes = [el].concat([].slice.call(el.querySelectorAll('*')));
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          if (n.getAttribute && n.getAttribute('aria-pressed') === 'true') return true;
          var cls = (n.getAttribute && n.getAttribute('class')) || '';
          if (/(^|[\s_-])(active|added|selected|in-wishlist|inwishlist|filled)([\s_-]|$)/i.test(cls)) return true;
        }
        return /added|remove/i.test(el.textContent || '');
      }

      function hideAppButton(root, primary) {
        if (root.getAttribute('data-hide-app-button') !== 'true' || !primary) return;
        var target = primary.closest('.shopify-app-block') || primary;
        if (target.contains(root)) target = primary;
        if (!target.classList.contains('kd-visually-hidden')) target.classList.add('kd-visually-hidden');
      }

      function syncState(root, primary) {
        var wishBtn = root.querySelector('[data-kd-wishlist]');
        var active = isActive(primary);
        if (wishBtn.classList.contains('is-active') !== active) {
          wishBtn.classList.toggle('is-active', active);
        }
      }

      // ── Bulk enquiry popup ──────────────────────────
      // The form is submitted the normal Shopify way (with its built-in spam protection).
      // After the page reloads, the popup opens by itself and shows the result.
      function initBulk(root) {
        var bulkBtn = root.querySelector('[data-kd-bulk]');
        var tpl = root.querySelector('[data-kd-modal-tpl]');
        if (!bulkBtn || !tpl) return;

        var formId = root.getAttribute('data-form-id') || '';

        var variantMap = {};
        var variantsEl = root.querySelector('[data-kd-variants]');
        if (variantsEl) {
          try { variantMap = JSON.parse(variantsEl.textContent); } catch (err) {}
        }

        var dlg = null;
        var form = null;
        var bodyEl = null;
        var successEl = null;
        var errorEl = null;
        var submitBtn = null;

        // Product link: includes the selected variant (?variant=ID in the URL)
        function getProductInfo() {
          var base = root.getAttribute('data-url') || (window.location.origin + window.location.pathname);
          var vid = '';
          try { vid = new URL(window.location.href).searchParams.get('variant') || ''; } catch (err) {}
          if (!vid) vid = root.getAttribute('data-default-variant') || '';
          var link = vid ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vid : base;
          var vtitle = variantMap[vid] || '';
          if (vtitle === 'Default Title') vtitle = '';
          return { link: link, variant: vtitle };
        }

        function build() {
          if (dlg) return dlg;
          var frag = tpl.content.cloneNode(true);
          dlg = frag.querySelector('dialog');
          form = dlg.querySelector('form');
          document.body.appendChild(frag);

          bodyEl = dlg.querySelector('[data-kd-modal-body]');
          successEl = dlg.querySelector('[data-kd-modal-success]');
          errorEl = dlg.querySelector('[data-kd-modal-error]');
          submitBtn = dlg.querySelector('[data-kd-modal-submit]');

          function close() {
            if (dlg.close) dlg.close();
            else dlg.removeAttribute('open');
            document.documentElement.style.overflow = '';
          }

          dlg.querySelectorAll('[data-kd-modal-close]').forEach(function (b) {
            b.addEventListener('click', close);
          });
          // Close when the backdrop is clicked
          dlg.addEventListener('click', function (e) {
            if (e.target === dlg) close();
          });
          dlg.addEventListener('close', function () {
            document.documentElement.style.overflow = '';
          });

          // Normal (native) submit: only set a default message and disable the button.
          // The browser checks the required fields itself, then sends the form to Shopify.
          form.addEventListener('submit', function () {
            var msg = form.querySelector('[name="contact[body]"]');
            if (!msg.value.trim()) msg.value = 'No additional message.';
            errorEl.hidden = true;
            submitBtn.disabled = true;
            submitBtn.textContent = 'Sending…';
          });

          // Re-enable the button when the user comes back with the browser's back button
          window.addEventListener('pageshow', function (ev) {
            if (ev.persisted && submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Send Enquiry';
            }
          });

          return dlg;
        }

        function fillFormInfo() {
          var info = getProductInfo();
          dlg.querySelector('[data-kd-f-link]').value = info.link;
          dlg.querySelector('[data-kd-f-variant]').value = info.variant;
        }

        function showDialog() {
          document.documentElement.style.overflow = 'hidden';
          if (dlg.showModal) dlg.showModal();
          else dlg.setAttribute('open', '');
        }

        function open() {
          build();
          fillFormInfo();

          // Start from a fresh state every time
          bodyEl.hidden = false;
          successEl.hidden = true;
          errorEl.hidden = true;

          showDialog();

          var first = dlg.querySelector('[data-kd-f-name]');
          if (first) setTimeout(function () { first.focus(); }, 50);
        }

        // After the reload: show the result Shopify returned inside the popup
        function autoOpenResult() {
          var posted = !!tpl.content.querySelector('[data-kd-posted]');
          var serverErrEl = tpl.content.querySelector('[data-kd-server-error]');
          var urlPosted = false;
          try {
            var u = new URL(window.location.href);
            urlPosted =
              u.searchParams.get('contact_posted') === 'true' &&
              !!formId &&
              u.hash === '#' + formId;
          } catch (err) {}

          if (!posted && !serverErrEl && !urlPosted) return;

          build();
          fillFormInfo();

          if (posted || urlPosted) {
            bodyEl.hidden = true;
            successEl.hidden = false;
            errorEl.hidden = true;
          } else {
            bodyEl.hidden = false;
            successEl.hidden = true;
            errorEl.textContent =
              serverErrEl.getAttribute('data-kd-server-error') ||
              'Could not send your enquiry. Please check the details and try again.';
            errorEl.hidden = false;
          }

          showDialog();

          // Clean the URL so the popup does not open again on refresh
          try {
            var cu = new URL(window.location.href);
            cu.searchParams.delete('contact_posted');
            cu.hash = '';
            window.history.replaceState(null, '', cu.pathname + cu.search);
          } catch (err) {}
        }

        bulkBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          open();
        });

        autoOpenResult();
      }

      function init(root) {
        if (root.__kdInit) return;
        root.__kdInit = true;

        var url = root.getAttribute('data-url');
        var title = root.getAttribute('data-title');
        var shareBtn = root.querySelector('[data-kd-share]');
        var menu = root.querySelector('[data-kd-menu]');
        var wishBtn = root.querySelector('[data-kd-wishlist]');
        var copyBtn = root.querySelector('[data-kd-copy]');

        function closeMenu() {
          if (!menu) return;
          menu.hidden = true;
          shareBtn.setAttribute('aria-expanded', 'false');
        }

        // Wishlist: trigger the app's own button
        wishBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var primary = findPrimary(root);
          if (!primary) {
            console.warn('kd-actions: wishlist app button not found on this page');
            return;
          }
          var target = pickTarget(primary);
          fire(target);
          setTimeout(function () { syncState(root, findPrimary(root)); }, 400);
          setTimeout(function () { syncState(root, findPrimary(root)); }, 1200);
        });

        // Share
        var links = {
          whatsapp: 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url),
          facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
          x: 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title),
          email: 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url)
        };
        menu.querySelectorAll('[data-kd-net]').forEach(function (a) {
          a.href = links[a.getAttribute('data-kd-net')];
        });

        shareBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var isTouch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
          if (isTouch && navigator.share) {
            navigator.share({ title: title, text: title, url: url }).catch(function () {});
            return;
          }
          var open = menu.hidden;
          menu.hidden = !open;
          shareBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        var instagramBtn = root.querySelector('[data-kd-instagram]');

        if (instagramBtn) {
          instagramBtn.addEventListener('click', async function (e) {
            e.preventDefault();
            e.stopPropagation();

            var productUrl = url;

            try {
              // Copy product link
              if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(productUrl);
              } else {
                var ta = document.createElement('textarea');
                ta.value = productUrl;
                document.body.appendChild(ta);
                ta.select();
                document.execCommand('copy');
                document.body.removeChild(ta);
              }

              instagramBtn.textContent = 'Link copied! Opening Instagram…';

              // Try opening Instagram app
              setTimeout(function () {
                var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

                if (isMobile) {
                  // Try Instagram app
                  window.location.href = 'instagram://app';

                  // Fallback to Instagram website
                  setTimeout(function () {
                    window.open('https://www.instagram.com/', '_blank', 'noopener');
                  }, 1200);
                } else {
                  // Desktop
                  window.open('https://www.instagram.com/', '_blank', 'noopener');
                }

                instagramBtn.textContent = 'Instagram';
                closeMenu();
              }, 500);
            } catch (err) {
              // Fallback
              window.open('https://www.instagram.com/', '_blank', 'noopener');

              instagramBtn.textContent = 'Instagram';
              closeMenu();
            }
          });
        }

        copyBtn.addEventListener('click', function () {
          var done = function () {
            copyBtn.textContent = 'Link copied!';
            setTimeout(function () {
              copyBtn.textContent = 'Copy link';
              closeMenu();
            }, 1200);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(done).catch(done);
          } else {
            var ta = document.createElement('textarea');
            ta.value = url;
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); } catch (err) {}
            document.body.removeChild(ta);
            done();
          }
        });

        menu.querySelectorAll('a').forEach(function (a) {
          a.addEventListener('click', function () { setTimeout(closeMenu, 100); });
        });

        document.addEventListener('click', function (e) {
          if (!root.contains(e.target)) closeMenu();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeMenu();
        });

        initBulk(root);
      }

      function run() {
        document.querySelectorAll('[data-kd-actions]').forEach(function (root) {
          init(root);
          var primary = findPrimary(root);
          hideAppButton(root, primary);
          syncState(root, primary);
        });
      }

      var scheduled = false;
      function schedule() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          run();
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
      } else {
        run();
      }
      document.addEventListener('shopify:section:load', run);
      document.addEventListener('shopify:block:select', run);

      // App buttons load late and change state: keep watching
      new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-pressed']
      });
    } catch (err) {
      console.warn('kd-actions error', err);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
